__turbopack_context__.v({
  "actions": "SaveTripButton-module__NR1O0a__actions",
  "body": "SaveTripButton-module__NR1O0a__body",
  "bodyModal": "SaveTripButton-module__NR1O0a__bodyModal",
  "footerModal": "SaveTripButton-module__NR1O0a__footerModal",
  "heading": "SaveTripButton-module__NR1O0a__heading",
  "text": "SaveTripButton-module__NR1O0a__text",
});
